<div *ngFor="let button of subcommandButtons">
  <commands-ui-single-subcommand-button
    [parentButton]="parentButton"
    [button]="button"
    (click)="toggleActive(button)"
  ></commands-ui-single-subcommand-button>
  <div *ngIf="button.subcommandCompExists">
    <commands-ui-subcommand-buttons
      [parentButton]="button"
      (subcommandChange)="setActiveButton($event)"
    ></commands-ui-subcommand-buttons>
  </div>
</div>
